import { ClassProvider } from '@angular/core';

import { Types } from '../../../domain/types.domain';
import { GetPylonCitiesService } from '../../../domain/auth/services/get-pylon-cities.service';

export class GetPylonCitiesServiceInstruction implements ClassProvider {
  provide = Types.GetPylonCitiesService;
  deps = [Types.Settings, Types.AuthRepository];
  useClass = GetPylonCitiesService;
}
